<div class="account-navigation" [class.sidebar-collapsed]="sidebarCollapsed" [class.mobile-view]="isMobile">
  <!-- Mobile Header Bar -->
  @if (isMobile) {
    <div class="mobile-header">
      <img id="mobile-logo" src="../../../../assets/master-logo-white-tight.svg" />
      <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" aria-label="Toggle navigation menu">
        <i class="fa-utility fa-semibold fa-bars"></i>
      </button>
    </div>
  }

  <!-- Mobile Menu Backdrop -->
  @if (isMobile && mobileMenuOpen) {
    <div class="mobile-backdrop" (click)="closeMobileMenu()"></div>
  }

  <!-- Sidenav -->
  <div
    class="sidenav"
    [class.collapsed]="sidebarCollapsed && !isMobile"
    [class.mobile-open]="isMobile && mobileMenuOpen"
    [class.mobile-closed]="isMobile && !mobileMenuOpen"
  >
    <div class="sidebar-header">
      <!-- Desktop header content -->
      @if (!isMobile) {
        @if (!sidebarCollapsed) {
          <img id="logo" src="../../../../assets/master-logo-white-tight.svg" />
        }
        <div class="" [ngClass]="sidebarCollapsed ? 'text-center margin-auto' : ''">
          @if (sidebarCollapsed) {
            <img class="favicon collapsed-logo" src="../../../../favicon-32x32.png" />
          }
          <button
            class="collapse-toggle collapsed-icon-link"
            [ngClass]="sidebarCollapsed ? 'margin-auto' : ''"
            (click)="toggleSidebar()"
            [pTooltip]="sidebarCollapsed ? 'View Menu' : ''"
            tooltipPosition="right"
          >
            <i class="fa-utility fa-semibold" [ngClass]="sidebarCollapsed ? 'fa-bars' : 'fa-xmark'"></i>
          </button>
        </div>
      }
      <!-- Mobile header content -->
      @if (isMobile) {
        <img id="logo" src="../../../../assets/master-logo-white-tight.svg" />
        <button class="mobile-close-btn" (click)="closeMobileMenu()" aria-label="Close navigation menu">
          <i class="fa-utility fa-semibold fa-xmark"></i>
        </button>
      }
    </div>

    @if ((isMobile && mobileMenuOpen) || (!isMobile && !sidebarCollapsed)) {
      <div class="nav-content" @fadeIn>
        @if (shouldShowWelcomeLink) {
          <div>
            <ul>
              <li>
                <a [routerLink]="welcomeUrl" routerLinkActive="activated-route">Welcome to Arpio!</a>
              </li>
            </ul>
          </div>
        }
        <!-- Search Filter -->
        @if (!loading) {
          <div class="nav-search">
            <div class="nav-search-field">
              <i class="fa-solid fa-magnifying-glass nav-search-icon"></i>
              <input
                type="text"
                placeholder="Search..."
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange()"
                class="nav-search-input"
                autocomplete="off"
                spellcheck="false"
              />
              @if (searchTerm) {
                <button class="nav-search-clear" (click)="clearSearch()" aria-label="Clear search">
                  <i class="fa-utility fa-semibold fa-xmark"></i>
                </button>
              }
            </div>
          </div>
        }
        <!-- No results -->
        @if (isSearching && !hasAnySearchMatch) {
          <div class="nav-no-results">No results for "{{ searchTerm }}"</div>
        }
        <!-- APPLICATIONS -->
        @if ((shouldShowApplicationsSection || loading) && (!isSearching || hasApplicationsMatch)) {
          <div>
            <h2
              class="nav-heading collapsible"
              [ngClass]="sections.applications ? 'open' : 'collapsed'"
              (click)="sections.applications = !sections.applications"
            >
              <i
                class="fa-utility fa-semibold"
                [ngClass]="sections.applications ? 'fa-angle-down' : 'fa-angle-right'"
              ></i>
              APPLICATIONS
            </h2>
            @if (sections.applications && loading) {
              <ul @slideDown>
                <li>
                  <div class="nav-entry"><i class="fa-solid fa-spinner fa-spin"></i> Loading applications...</div>
                </li>
              </ul>
            }
            @if (sections.applications && !loading) {
              <ul @slideDown>
                @if (
                  canCreateApplications && (!isSearching || applicationsSectionMatch || matchesSearch('Create New ...'))
                ) {
                  <li>
                    <a
                      data-cy="create-application-button"
                      [routerLink]="createApplicationUrl"
                      routerLinkActive="activated-route"
                      >+ Create New ...</a
                    >
                  </li>
                }
                @for (
                  application of filteredApplications | sort: 'name' : true;
                  track applicationTrackBy($index, application)
                ) {
                  <li>
                    <div class="flex-center-row nav-entry">
                      <div class="spacer">
                        <a
                          [routerLink]="application.url"
                          routerLinkActive="activated-route"
                          [routerLinkActiveOptions]="{ exact: false }"
                          >{{ application.name }}</a
                        >
                      </div>
                      @if (application?.isDeleted) {
                        <div class="nav-glyph deleted-app">D</div>
                      }
                      @switch (application.syncPhase) {
                        @case ('failover') {
                          <div class="nav-glyph recovery-phase">R</div>
                        }
                        @case ('failoverTest') {
                          <div class="nav-glyph test-phase">T</div>
                        }
                      }
                    </div>
                    @if (application.issueCount > 0) {
                      <ul class="no-right-margin">
                        <li class="no-right-margin">
                          <div class="flex-center-row nav-entry">
                            <div class="spacer">
                              <a
                                [routerLink]="application.url"
                                routerLinkActive="activated-route"
                                [routerLinkActiveOptions]="{ exact: false }"
                                (click)="navigateToIssues($event, application)"
                                >Issues</a
                              >
                            </div>
                            <div class="flex gap-2 items-center">
                              <div class="nav-glyph issue-count">{{ application.issueCount }}</div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    }
                  </li>
                }
              </ul>
            }
          </div>
        }
        <!-- ACCOUNT -->
        @if (!isSearching || hasAccountMatch) {
          <div #accountSection>
            <h2
              data-cy="account-menu"
              class="nav-heading collapsible"
              [ngClass]="sections.account ? 'open' : 'collapsed'"
              (click)="sections.account = !sections.account"
            >
              <i class="fa-utility fa-semibold" [ngClass]="sections.account ? 'fa-angle-down' : 'fa-angle-right'"></i>
              ACCOUNT
            </h2>
            @if (sections.account) {
              <ul @slideDown>
                @if (accountSectionMatch || accountSettingsMatch) {
                  <li>
                    <a [routerLink]="accountSettingsUrl" routerLinkActive="activated-route">Settings</a>
                  </li>
                }
                @if (accountSectionMatch || accessManagementMatch) {
                  <li>
                    <a [routerLink]="accessManagementUrl" routerLinkActive="activated-route">Access Management</a>
                  </li>
                }
                @if (usageBillingVisible && (accountSectionMatch || usageBillingMatch)) {
                  <li>
                    <a [routerLink]="usageBillingUrl" routerLinkActive="activated-route" data-cy="usage-billing-link"
                      >Usage &amp; Billing</a
                    >
                  </li>
                }
                @if (licensedForIntegrations && (accountSectionMatch || matchesSearch('Add Ons'))) {
                  <li>
                    <a [routerLink]="integrationsUrl" routerLinkActive="activated-route">Add Ons</a>
                  </li>
                }
              </ul>
            }
          </div>
        }
        <!-- HELP -->
        @if (!isSearching || hasHelpMatch) {
          <div #helpSection>
            <h2
              class="nav-heading collapsible"
              [ngClass]="sections.help ? 'open' : 'collapsed'"
              (click)="sections.help = !sections.help"
            >
              <i class="fa-utility fa-semibold" [ngClass]="sections.help ? 'fa-angle-down' : 'fa-angle-right'"></i>
              HELP
            </h2>
            @if (sections.help) {
              <ul @slideDown>
                @if (helpSectionMatch || matchesSearch('Support')) {
                  <li>
                    <a [routerLink]="accountSupportUrl" routerLinkActive="activated-route">Support</a>
                  </li>
                }
                @if (helpSectionMatch || matchesSearch('Documentation')) {
                  <li>
                    <a id="docs-link" target="_blank" [href]="uiService.documentationUrl">Documentation</a>
                  </li>
                }
              </ul>
            }
          </div>
        }
        @if (!isSearching || matchesSearch('Sign Out')) {
          <a id="logout-link" routerLink="" (click)="logoutClick()"
            >Sign Out &nbsp;<i class="fa-utility fa-semibold fa-arrow-right-from-bracket"></i
          ></a>
        }
      </div>
    }

    <!-- Collapsed sidebar icons (desktop only) -->
    @if (sidebarCollapsed && !isMobile) {
      <div class="collapsed-icons">
        <button class="collapsed-icon-link" (click)="toggleSidebar()" pTooltip="Search" tooltipPosition="right">
          <i class="fa-solid fa-magnifying-glass"></i>
        </button>
        <button
          class="collapsed-icon-link"
          (click)="expandSidebarAndSection('account')"
          pTooltip="Account"
          tooltipPosition="right"
        >
          <i class="fa-solid fa-gears"></i>
        </button>
        <button
          class="collapsed-icon-link"
          (click)="expandSidebarAndSection('help')"
          pTooltip="Help"
          tooltipPosition="right"
        >
          <i class="fa-utility fa-semibold fa-question"></i>
        </button>
        <a
          class="collapsed-icon-link"
          routerLink=""
          (click)="logoutClick()"
          pTooltip="Sign Out"
          tooltipPosition="right"
        >
          <i class="fa-utility fa-semibold fa-arrow-right-from-bracket"></i>
        </a>
      </div>
    }
  </div>

  <div class="main light">
    <router-outlet></router-outlet>
    @if (!readyToShowContent) {
      <div class="loading-main-app loading-overlay">
        <h1><i class="fa-solid fa-spinner fa-spin font-size-inherit"></i> Loading</h1>
      </div>
    }
  </div>
</div>
